<template>
    <div class="modal modal-change-plan fade" id="changePlanModal" tabindex="-1" role="dialog" aria-labelledby="changePlanModal" aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title">Change Your Plan</h5>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">Close</button>
                </div>
                <div class="modal-body">
                    <div class="plans">
                        <div class="row" >
                            <div :class="['col-sm-6 text-center mb-4']" v-for="(plan, index) in plans" :key="plan.id">
                                <div class="plan-hold">
                                    <div :class="['plan', isActivePlan(plan.id) ? 'current-plan': '']">
                                        <span class="period">{{ plan.title }}</span>
                                        <strong class="price"><sup>$</sup>{{ plan.price_per_month }}</strong>
                                        <span class="per">per month</span>
                                        <span class="sep"></span>
                                        <span class="note">Pay ${{ plan.price_per_month }} every month</span>
                                        <span class="popular" v-if="plan.popular">Most Popular</span>
                                    </div>
                                </div>
                                <a
                                    href="javascript:void(0)"
                                    :class="['btn btn-outline', isActivePlan(plan.id) ? 'current-plan': '']"
                                    @click="updatePlan(plan.id)"
                                >
                                    {{ isActivePlan(plan.id) ? 'Cancel Plan' : 'Upgrade Plan' }}
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "SubscriptionPlanListModal",
        props: {
            input_plans: {
                type: Array,
                required: true
            },
            input_active_subscription: {
                type: Object,
                required: false,
                default: null
            },
        },
        data() {
            return {
                plans: [...this.input_plans],
                active_subscription: {...this.input_active_subscription}
            }
        },
        methods: {
            isActivePlan(planId) {
                return this.active_subscription && planId === this.active_subscription.subscription_id;
            },
            updatePlan(planId) {
                if (this.isActivePlan(planId)) {
                    this.cancelPlan();
                } else {
                    this.upgradePlan(planId);
                }
            },
            upgradePlan(id) {
                this.showLoading();

                axios.post(`/subscription/change`, { subscription_id: id })
                    .then(response => {
                        let timeoutId = setTimeout(() => {
                            this.$swal.fire({
                                title: `Success!`,
                                text: response.data.message,
                                icon: 'success',
                            });

                            this.$emit('upgrade', response.data.data);
                            this.active_subscription = response.data.data;
                        }, 800)
                    })
                    .catch(error => {
                        this.showErrorMessage('upgrade', error);
                    })
            },
            cancelPlan() {
                this.showLoading();

                axios.delete(`/subscription/cancel/${this.active_subscription.id}`)
                    .then(response => {
                        setTimeout(() => {
                            this.$swal.fire({
                                title: `Success!`,
                                text: 'Your subscription has been successfully canceled',
                                icon: 'success',
                            });

                            this.active_subscription = null;
                            this.$emit('cancel');
                        }, 800)
                    })
                    .catch(error => {
                        this.showErrorMessage('cancel', error);
                    })
            },
            showErrorMessage(el, error) {
                this.$swal.fire({
                    title: `Can not ${el} your subscription!`,
                    text: error.response.data.message,
                    icon: 'error',
                });
            },
            showLoading() {
                this.$swal.fire({
                    icon: 'info',
                    title: 'Please Wait!',
                    html: 'Your information is being submitted',
                    allowOutsideClick: false,
                    showCancelButton: false,
                    showConfirmButton: false,
                    willOpen: () => {
                        this.$swal.showLoading();
                    }
                });
            },
        }
    }
</script>

<style scoped lang="less">
    .plan.current-plan {
        border: 2px solid #f7c44e !important;
        border-radius: 0.625rem !important;
    }

    .btn.current-plan {
        background: transparent;
        border: 1px solid #000000;

        &:hover {
            background: #e2e2e2;
        }
    }
</style>
